if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          prodTitle: ".m-sticky-addtocart__title",
          mainImage: ".m-sticky-addtocart__image",
          price: ".m-sticky-addtocart__price",
          comparePrice: ".m-sticky-addtocart__compare-price",
          saveBadge: ".m-sticky-addtocart__badge",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
        };

        this.hasCustomFields = !!document.querySelector(
          ".m-main-product--info .m-product-custom-field"
        );
      }

      connectedCallback() {
        this.container = this.closest(".m-sticky-addtocart") || this;
        this.mainProductForm = document.querySelector(".m-product-form--main");
        this.mainProductInfo = document.querySelector(".m-main-product--info");
        this.mainAddToCart = this.mainProductForm
          ? this.mainProductForm.querySelector(".m-add-to-cart")
          : null;
        this.mainDynamicCheckout = this.mainProductForm
          ? this.mainProductForm.querySelector(this.selectors.buyNowBtn)
          : null;

        this.productId = this.dataset.productId;
        this.moneyFormat = this.dataset.moneyFormat || "${{amount}}";
        this.buttonLabel = "COMPRAR AHORA";
        this.soldOutLabel =
          (window.MinimogStrings && window.MinimogStrings.soldOut) || "Agotado";

        this.domNodes = queryDomNodes(this.selectors, this.container);
        this.variantData = this.getVariantData();

        this.init();
        this.syncInitialVariant();
        this.setStickyAddToCartHeight();

        if (this.mainProductForm) {
          this.mainProductForm.addEventListener("change", () => {
            setTimeout(() => {
              const variant = this.getCurrentMainVariant();
              if (variant) {
                this.currentVariant = variant;
                this.renderVariant(variant);
              }
            }, 60);
          });
        }

        document.addEventListener("matchMobile", () => {
          this.setStickyAddToCartHeight();
        });

        document.addEventListener("unmatchMobile", () => {
          this.setStickyAddToCartHeight();
        });

        window.addEventListener("resize", () => {
          this.setStickyAddToCartHeight();
        });
      }

      getVariantData() {
        const jsonNode = this.container.querySelector('[type="application/json"]');
        if (!jsonNode) return [];
        this.variantData = this.variantData || JSON.parse(jsonNode.textContent);
        return this.variantData;
      }

      init() {
        if (!this.mainAddToCart) {
          this.container.style.setProperty("--m-translate-y", 0);
          return;
        }

        const { prodTitle, mainImage, addToCart, buyNowBtn, foxkitBtn } = this.domNodes;
        if (buyNowBtn) this.enable_dynamic_checkout = true;

        const headerHeight = MinimogSettings.headerHeight || 66;
        const rootMargin = `${headerHeight}px 0px 0px 0px`;

        if ("IntersectionObserver" in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.intersectionRatio !== 1) {
                  this.container.style.setProperty("--m-translate-y", 0);
                } else {
                  this.container.style.setProperty("--m-translate-y", "100%");
                }

                document.documentElement.classList[
                  entry.intersectionRatio !== 1 ? "add" : "remove"
                ]("stick-atc-show");
              });
            },
            { threshold: 1, rootMargin }
          );
        }

        if (prodTitle) {
          prodTitle.addEventListener("click", () => __scrollToTop());
        }

        if (mainImage) {
          mainImage.addEventListener("click", () => __scrollToTop());
        }

        if (this.hasCustomFields) {
          let hasCustomFieldRequired = false;
          const customFields = document.querySelectorAll(
            ".m-main-product--info .m-product-custom-field"
          );

          customFields.forEach((item) => {
            const field = item.querySelector(".form-field");
            if (field && field.value === "" && field.hasAttribute("required")) {
              hasCustomFieldRequired = true;
            }
          });

          if (hasCustomFieldRequired && addToCart) {
            addToCart.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              __scrollToTop(this.mainProductForm, () => this.mainAddToCart.click());
            });
          }

          if (buyNowBtn) {
            buyNowBtn.addEventListener(
              "click",
              (e) => {
                const missing = validateForm(this.mainProductInfo);
                if (missing.length > 0) {
                  e.preventDefault();
                  e.stopPropagation();
                  __scrollToTop(this.mainProductForm, () =>
                    this.mainDynamicCheckout.click()
                  );
                }
              },
              true
            );
          }

          if (foxkitBtn) {
            foxkitBtn.addEventListener("click", (e) => {
              e.preventDefault();
              __scrollToTop(this.mainProductForm, () => this.mainAddToCart.click());
            });
          }
        }

        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      setObserveTarget() {
        if (this.observer && this.mainProductForm) {
          this.observer.observe(this.mainProductForm);
          this.observeTarget = this.mainProductForm;
        }
      }

      getCurrentMainVariant() {
        if (!this.mainProductForm) return this.variantData[0] || null;

        const mainVariantInput = this.mainProductForm.querySelector('[name="id"]');
        const variantId = Number(mainVariantInput && mainVariantInput.value);

        return (
          this.variantData.find((variant) => Number(variant.id) === variantId) ||
          this.variantData[0] ||
          null
        );
      }

      syncInitialVariant() {
        const variantInput = this.querySelector('[name="id"]');
        const initialVariant = this.getCurrentMainVariant();

        if (!initialVariant) return;

        if (variantInput) {
          variantInput.value = initialVariant.id;
        }

        this.currentVariant = initialVariant;
        this.renderVariant(initialVariant);
      }

      getVariantImage(variant) {
        if (!variant) return "";

        if (variant.featured_image && variant.featured_image.src) {
          return variant.featured_image.src;
        }

        if (variant.image) {
          return variant.image;
        }

        if (
          variant.featured_media &&
          variant.featured_media.preview_image &&
          variant.featured_media.preview_image.src
        ) {
          return variant.featured_media.preview_image.src;
        }

        return "";
      }

      formatMoney(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
          return window.Shopify.formatMoney(cents, this.moneyFormat);
        }

        return `${(cents / 100).toFixed(2)}€`;
      }

      renderVariant(variant) {
        const { mainImage, price, comparePrice, saveBadge } = this.domNodes;

        if (!variant) {
          this.updateButton(true, "", true);
          return;
        }

        const variantInput = this.querySelector('[name="id"]');
        if (variantInput) {
          variantInput.value = variant.id;
        }

        const variantPrice = Number(variant.price || 0);
        const variantCompare = Number(variant.compare_at_price || 0);

        if (price) {
          price.textContent = this.formatMoney(variantPrice);
        }

        if (comparePrice) {
          if (variantCompare > variantPrice) {
            comparePrice.textContent = this.formatMoney(variantCompare);
            comparePrice.style.display = "";
          } else {
            comparePrice.textContent = "";
            comparePrice.style.display = "none";
          }
        }

        if (saveBadge) {
          if (variantCompare > variantPrice) {
            const savePercent = Math.round(
              ((variantCompare - variantPrice) * 100) / variantCompare
            );
            saveBadge.textContent = `AHORRAS ${savePercent}%`;
            saveBadge.style.display = "";
          } else {
            saveBadge.textContent = "";
            saveBadge.style.display = "none";
          }
        }

        if (mainImage) {
          const variantImage = this.getVariantImage(variant);
          if (variantImage) {
            mainImage.src = variantImage;
          }
        }

        if (!variant.available) {
          this.updateButton(true, this.soldOutLabel);
        } else {
          this.updateButton(false);
        }
      }

      updateButton(disable = true, text) {
        const productForm = this.querySelector(".sticky-atc-form");
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector(
          '[name="add"] .m-add-to-cart--text'
        );

        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          addButton.classList.add("disabled");
          if (addButtonText) {
            addButtonText.textContent = text || this.soldOutLabel;
          }
        } else {
          addButton.removeAttribute("disabled");
          addButton.classList.remove("disabled");
          if (addButtonText) {
            addButtonText.textContent = this.buttonLabel;
          }
        }
      }

      syncWithMainProductForm() {
        const variantInput = this.querySelector('[name="id"]');

        if (
          window.MinimogEvents &&
          typeof window.MinimogEvents.subscribe === "function"
        ) {
          window.MinimogEvents.subscribe(
            `${this.productId}__VARIANT_CHANGE`,
            async (variant) => {
              if (!variant) return;

              if (variantInput) {
                variantInput.value = variant.id;
              }

              this.currentVariant = variant;
              this.renderVariant(variant);
            }
          );
        }
      }

      setStickyAddToCartHeight() {
        document.documentElement.style.setProperty(
          "--f-sticky-atc-bar-height",
          this.offsetHeight + "px"
        );
        window.MinimogSettings.stickyAddToCartHeight = this.offsetHeight;
      }
    }
  );
}